export const VIEW_MODES = {
  DEFAULT: 'DEFAULT' as const,
  LABEL: 'LABEL' as const,
  BLOCKER: 'BLOCKER' as const,
  SEARCH: 'SEARCH' as const,
}
